import {Component, Input, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ConstantsService} from '../../fidelidade/ConstantsService';
import {WhatsappV4Service} from '../../services/whatsapp-v4.service';
import {ExtensaoWhatsapp, extensaoDoNumero} from '../extensoes-whatsapp';

/**
 * Extensão do número principal da loja: status, download e troca V3/V4 com os passos de instalação.
 * Compartilhado pelo menu-v2 e pelo menu antigo; quem hospeda decide onde o painel aparece.
 */
@Component({
  selector: 'app-extensao-whatsapp-painel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './extensao-whatsapp-painel.component.html',
  styleUrls: ['./extensao-whatsapp-painel.component.scss']
})
export class ExtensaoWhatsappPainelComponent implements OnInit {
  @Input() empresa: any;
  @Input() usuario: any;
  /** Só a V4 é verificável; null enquanto consulta ou na V3. */
  conectada: boolean | null = null;
  confirmando = false;
  trocando = false;
  erro = '';
  /** Versão para a qual acabou de trocar: o painel fica no passo de instalar. */
  trocouPara: ExtensaoWhatsapp | null = null;

  constructor(private whatsappV4: WhatsappV4Service, private constants: ConstantsService) {}

  get extensao(): ExtensaoWhatsapp {
    return extensaoDoNumero(this.empresa?.numeroWhatsapp);
  }

  get outra(): ExtensaoWhatsapp {
    return extensaoDoNumero({versaoExtensao: this.extensao.versao === 4 ? 3 : 4});
  }

  /** Trocar exige admin, como na tela de números; o servidor confere de novo. */
  get podeTrocar(): boolean {
    return !!(this.usuario?.admin || this.usuario?.superadmin) && !!this.empresa?.numeroWhatsapp?.id;
  }

  ngOnInit(): void {
    const numero = this.empresa?.numeroWhatsapp;
    if (numero?.id && this.extensao.versao === 4) {
      this.whatsappV4.obtenhaPolitica(this.empresa, numero)
        .then((resposta: any) => this.conectada = !!resposta?.extensaoV4Conectada)
        .catch(() => {});
    }
  }

  confirmar(): void {
    if (this.trocando) return;
    const destino = this.outra;
    this.trocando = true;
    this.erro = '';
    this.whatsappV4.troqueVersaoExtensao(this.empresa, this.empresa.numeroWhatsapp, destino.versao).then(() => {
      this.trocando = false;
      this.confirmando = false;
      this.trocouPara = destino;
      this.constants.recarregueEmpresa();
    }).catch((erro: any) => {
      this.trocando = false;
      this.erro = erro || 'Não foi possível trocar a extensão. Tente de novo.';
    });
  }
}
